<template lang='pug'>
v-container(fluid class="pa-0")
  v-app-bar(app, flat, dense, fixed)
    v-app-bar-nav-icon(@click='toggleDrawerMenu')
    v-toolbar-title(class='subtitle-1') ユーザー情報
  v-container(fluid)
    v-row(class='d-flex flex-column')
      v-card(flat, class='ma-4')
        v-card-title
          v-row
            v-card(flat) 
              v-img(height='60', width="60", :src='getImageUrl("userImageId")', class='mr-4')
            v-card(flat) {{recordToEdit.displayName}} {{recordToEdit.lastName}} {{recordToEdit.firstName}} 
        v-card-text
          v-card(flat)
            v-row(flat, class='d-flex')
              v-row
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='表示名', v-model='recordToEdit.displayName', dense, readonly, disabled)
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='苗字', v-model='recordToEdit.lastName', dense)
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='名前', v-model='recordToEdit.firstName', dense)
              v-row
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='Slack Id', v-model='recordToEdit.slackId', dense, disabled)
                v-card(max-width="200", flat, class="ml-2")
                  v-text-field(label='電話番号', v-model='recordToEdit.telephoneNumber', dense)
              v-row
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 1', v-model='recordToEdit.familyName1', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 2', v-model='recordToEdit.familyName2', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 3', v-model='recordToEdit.familyName3', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 4', v-model='recordToEdit.familyName4', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 5', v-model='recordToEdit.familyName5', dense)
        v-card-actions
          v-spacer
          v-btn(text, @click='reloadUser()') 再読込
          v-btn(text, @click='updateUser()', :disabled='inProcess') 保存
      v-card(flat, class='ma-4 d-flex flex-column')
        .subtitle サウンド設定
        v-switch(v-model='loginSound', label='開始時のサウンドを再生する', dense)
        v-switch(v-model='logoffSound', label='終了時のサウンドを再生する', dense)
        v-switch(v-model='commentSound', label='コメントのサウンドを再生する', dense)
        v-switch(v-model='reactionSound', label='リアクションのサウンドを再生する', dense)
        v-switch(v-model='pictureSound', label='画像変更時のサウンドを再生する', dense)
        v-switch(v-model='weeklySound', label='週報変更時のサウンドを再生する', dense)
        v-switch(v-model='approvalSound', label='(管理者)承認活動のサウンドを再生する', dense, v-if="isAdmin")
        v-switch(v-model='errorSound', label='(管理者)エラーのサウンドを再生する', dense, v-if="isAdmin")
        v-switch(v-model='onlyDisplayingUsers', label='表示中のメンバーのみのサウンドを再生する', dense)
        v-slider(v-model='volume',:min='5',:max='500', label='ボリューム(標準:50)', thumb-label="always", dense, class='pt-5')
        v-switch(v-model='isPrivacyMode', label='プライバシーモード（NGワードを置換します）', dense)
      v-card(flat, class='ma-4')
        v-card-title
          .subtitle 曜日別デフォルト勤怠区分
        v-card-text
          v-simple-table(dense)
            template(v-slot:default)
              thead
                tr
                  th 曜日
                  th 午前
                  th 午後
              tbody
                tr(v-for="(dayName, dayIndex) in dayNames", :key="dayIndex")
                  td {{ dayName }}
                  td
                    v-select(:items='workTypesWithDefault', item-text="name", item-value='tenantWorkTypeId', v-model='scheduleAM[dayIndex]', dense, hide-details, class="schedule-select")
                  td
                    v-select(:items='workTypesWithDefault', item-text="name", item-value='tenantWorkTypeId', v-model='schedulePM[dayIndex]', dense, hide-details, class="schedule-select")
          v-btn(text, @click='saveSchedule()', :disabled='inProcess', class='mt-2') スケジュール保存
      v-card(flat, class='ma-4')
        v-card-title
          v-row(class='d-flex flex-column')
            .subtitle プロファイル写真
            v-row 
              v-img(:height='100', :width="100", :max-width='100', contain, :src='getImageUrl("userImageId")', class='mr-4')
              v-card(min-width="200", flat, class="ml-2")
                v-file-input(label='画像ファイル', v-model='userImage', min-width='200')
              v-btn(text, @click='uploadImage("userImage")', :disabled='userImage==null || inProcess') 写真の更新
            .subtitle その他写真１
            v-row 
              v-img(:height='100', :width="100", :max-width='100', contain ,:src='getImageUrl("userFamilyImageId")', class='mr-4')
              v-card(min-width="200", flat, class="ml-2")
                v-file-input(label='画像ファイル', v-model='userImage2', min-width='200')
              v-btn(text, @click='uploadImage("userImage2")', :disabled='userImage2==null || inProcess') 写真の更新
              v-spacer
            .subtitle その他写真２
            v-row 
              v-img(:height='100', :width="100", :max-width='100', contain, :src='getImageUrl("userImage3Id")', class='mr-4')
              v-card(min-width="200", flat, class="ml-2")
                v-file-input(label='画像ファイル', v-model='userImage3', min-width='200')
              v-btn(text, @click='uploadImage("userImage3")', :disabled='userImage3==null || inProcess') 写真の更新
            .subtitle その他写真３
            v-row 
              v-img(:height='100', :width="100", :max-width='100', contain, :src='getImageUrl("userImage4Id")', class='mr-4')
              v-card(min-width="200", flat, class="ml-2")
                v-file-input(label='画像ファイル', v-model='userImage4', min-width='200')
              v-btn(text, @click='uploadImage("userImage4")', :disabled='userImage4==null || inProcess') 写真の更新
      v-card(flat, class='ma-4')
        v-card-title 
          v-row(class='d-flex flex-column',v-if="$store.direct.state.Login.userInfo.githubUserToken == null")
            v-btn(outline, @click='githubAuth()') GitHub 連携
          v-row(v-else, class='d-flex flex-column')
            v-alert(dense,text,type="success")  GitHub 連携済み
            v-btn(text, color="error", @click='githubDisconnect()', :disabled='inProcess', class='mt-2') GitHub 連携を解除
</template>

<script>
import basic from '@/components/mixins/basic'
import moment from "moment-timezone";
import { detect } from 'detect-browser';
moment.locale('ja')

export default {
  mixins: [basic],
  components: {
  },
  computed: {
    isAdmin: { get () { return this.$store.getters['Login/isAdmin'] }},
    firstCalendars() {
      return this.members.length>0 ? this.members[0].dates : []
    },
    loginSound: {
      get() { return this.$store.state.Home.loginSound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'loginSound', value: value}) }  
    },
    commentSound: {
      get() { return this.$store.state.Home.commentSound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'commentSound', value: value}) }  
    },
    reactionSound: {
      get() { return this.$store.state.Home.reactionSound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'reactionSound', value: value}) }  
    },
    pictureSound: {
      get() { return this.$store.state.Home.pictureSound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'pictureSound', value: value}) }  
    },
    weeklySound: {
      get() { return this.$store.state.Home.weeklySound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'weeklySound', value: value}) }  
    },
    approvalSound: {
      get() { return this.$store.state.Home.approvalSound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'approvalSound', value: value}) }  
    },
    errorSound: {
      get() { return this.$store.state.Home.errorSound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'errorSound', value: value}) }  
    },
    onlyDisplayingUsers: {
      get() { return this.$store.state.Home.onlyDisplayingUsers },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'onlyDisplayingUsers', value: value}) }  
    },
    volume: {
      get() { return this.$store.state.Home.volume },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'volume', value: value}) }  
    },
    logoffSound: {
      get() { return this.$store.state.Home.logoffSound },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'logoffSound', value: value}) }  
    },
    isPrivacyMode: {
      get() { return this.$store.direct.state.Home.isPrivacyMode },
      set(value) { this.$store.commit('Home/SET_VALUE', {name: 'isPrivacyMode', value: value}) }
    },
    workTypesWithDefault () {
      return [{ tenantWorkTypeId: null, name: '（グループデフォルト）' }, ...this.workTypes]
    }
  },
  data() {
    return {
      recordToEdit: {},
      inProcess: false,
      userImage: null,
      userImage2: null,
      userImage3: null,
      userImage4: null,
      workTypes: [],
      dayNames: ['日', '月', '火', '水', '木', '金', '土'],
      scheduleAM: [null, null, null, null, null, null, null],
      schedulePM: [null, null, null, null, null, null, null],
    }
  },
  mounted() {
    this.browser = detect()
    if (this.browser !== null) {
      if (this.browser.os.includes('iOS') || this.browser.os.includes('Android')) {
        this.dateStyle = 'input'
        this.timeStyle = 'time'
      }
    }
    this.yearMonthDate = moment([moment().year(), moment().month(), 1])
  },
  methods: {
    async masterReady () {
      this.recordToEdit = JSON.parse(JSON.stringify(this.$store.state.Login.userInfo))
      this.workTypes = await this.$store.dispatch("Calendar/getWorkTypes")
      await this.loadSchedule()
    },
    async loadSchedule () {
      var userDetailId = this.$store.state.Login.userInfo && this.$store.state.Login.userInfo.userDetailId
      if (!userDetailId) return
      try {
        var schedules = await this.$store.dispatch("Calendar/getUserDefaultSchedules", userDetailId)
        this.scheduleAM = [null, null, null, null, null, null, null]
        this.schedulePM = [null, null, null, null, null, null, null]
        if (schedules) {
          schedules.forEach(s => {
            if (s.dayOfWeek >= 0 && s.dayOfWeek <= 6) {
              this.scheduleAM[s.dayOfWeek] = s.tenantWorkTypeIdAM || null
              this.schedulePM[s.dayOfWeek] = s.tenantWorkTypeIdPM || null
            }
          })
          this.scheduleAM = [...this.scheduleAM]
          this.schedulePM = [...this.schedulePM]
        }
      } catch (e) { console.error('Failed to load schedules:', e) }
    },
    async saveSchedule () {
      if (this.inProcess) return
      this.inProcess = true
      try {
        var userDetailId = this.$store.state.Login.userInfo && this.$store.state.Login.userInfo.userDetailId
        if (!userDetailId) return
        for (var i = 0; i < 7; i++) {
          await this.$store.dispatch("Calendar/setUserDefaultSchedule", {
            userDetailId, dayOfWeek: i,
            tenantWorkTypeIdAM: this.scheduleAM[i],
            tenantWorkTypeIdPM: this.schedulePM[i]
          })
        }
        this.dispSuccess('スケジュールを保存しました。')
      } catch { this.dispError('スケジュールの保存に失敗しました。') }
      this.inProcess = false
    },
    async search () {
      await this.$store.dispatch('Login/getUserInfo')
      this.recordToEdit = JSON.parse(JSON.stringify(this.$store.state.Login.userInfo)) 
    },
    async reloadUser () {
      this.search()
    },
    async updateUser () {
      if (this.inProcess) {return}
      this.inProcess = true
      try {
        await this.$store.dispatch("Users/updatePersonal", this.recordToEdit)
        this.recordToEdit = {}
        this.search()
        this.dispSuccess('保存しました。')
      } catch {
        this.dispError('保存に失敗しました。')
      }
      this.inProcess = false

    },
    async uploadImage (name) {
      if (this.inProcess) {return}
      this.inProcess = true
      try {
        await this.$store.dispatch("Users/updateImage", {File: this[name], AspNetId: this.recordToEdit.aspNetId, ImageType: name})
        this.dialogPicture = false
        this.imageFile = null
        this.search()
        this[name] = null
        this.dispSuccess('画像を更新しました。')
      } catch {
        this.dispError('画像の更新に失敗しました。')
      }
      this.inProcess = false
    },
    getImageUrl(imageType) {
      if (this.recordToEdit[imageType] == null) { return this.site.deployFolder + '/noimage.png'}
      var result = this.$store.getters["Users/userImageUrl"] + this.recordToEdit[imageType]
      return result
    },
    toggleDrawerMenu () {
      this.$emit('toggle')
    },
    async githubAuth() {
      await this.$store.direct.dispatch.Github.auth()
    },
    async githubDisconnect() {
      if (this.inProcess) return
      if (!confirm('GitHub連携を解除しますか？')) return
      this.inProcess = true
      try {
        await this.$store.direct.dispatch.Github.disconnect()
        this.dispSuccess('GitHub連携を解除しました。')
        this.search()
      } catch {
        this.dispError('GitHub連携の解除に失敗しました。')
      }
      this.inProcess = false
    }
  }
};
</script>

<style>
.timerow {
  border-bottom-style: solid;
  border-bottom-width: 1pt;
  border-bottom-color:lightgray;
}
.timecell {
  background-color: transparent !important;
}
.odd {
  background-color: rgb(232, 232, 232);
}
.user-table td {
  padding-top: 3px;
  padding-bottom: 3px;
}
.user-image {
  width: 40px;
  height: 40px;
  border-radius: 20%;
  border-style: solid;
  border-width: 0.5px;
  border-color: lightgray;
}
.inactive {
  -webkit-filter: grayscale() opacity(.5);
  filter: grayscale() opacity(.5);
}
/* .timeinput fieldset {
  border-color: rgb(210, 210, 210) !important;
  height: 41px !important;
  background-color: white !important;
}
*/
.timesheet-table {
  width: 100%;
}

label.v-label {
  font-size: .8em !important;
}
.centered-input input {
  text-align: center
}
.member-plan-cell {
  font-size: .7em;
}
.member-activity-table {
  padding:0em 2em;
  border-collapse: collapse;
  border-left-style: solid;
  border-left-width: 1px;
  border-left-color: #ccc;
  border-top-style: solid !important;
  border-top-width: 1px;
  border-top-color: #ccc;
}
.member-activity-table td {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;

}
.member-activity-table th {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;

}
.approve-title {
  font-weight: bold;
  color: black !important;
}
.list-input-group{
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  align-items: center;
  min-height: 2rem;
}
</style>